import api from '../../../api/apiClient';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export async function createProject(payload) {
  if (!payload) throw new Error('Project payload is required to create new project');

  await unwrap(await api.post('/api/analyst/job/create', payload));
}
